class DialogHandler {
    constructor(el) {
        this.dialog = el;
        this.openButton = el.nextElementSibling;
        this.closeButton = document.querySelector("#close-weather");

        // Initialize event listeners
        this.init();
    }

    // Initialize the event listeners for the buttons
    init() {
        this.openButton.addEventListener('click', () => this.openDialog());
        this.closeButton.addEventListener('click', () => this.closeDialog());
    }

    // Function to open the dialog
    openDialog() {
        this.dialog.showModal();
    }

    // Function to close the dialog
    closeDialog() {
        this.dialog.close();
    }
}

export default DialogHandler;
